// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251910/js/" + chunkId + "." + {"44":"1b09c1f5","225":"be9b3275","481":"0206b8d2","486":"c2965314","770":"153e126a"}[chunkId] + ".0.8022089833746037.chunk.js";
};